import { faFloppyDisk } from '@fortawesome/free-regular-svg-icons';
import React, { Fragment, Suspense, useEffect, useState } from 'react';
import { useForm, Controller } from "react-hook-form";
import WhatsappComponent from '../../../Common/WhatsappComponent';
import PreviewPanel from '../../WhatsappComponents/PreviewPanel';
import CommonHeaderContent from '../../../Common/CommonHeaderContent';
import { Col, Row } from "react-bootstrap";
import Select from "react-select";
import { isValidEmail, isValidMobileNumber } from '../../../Common/Appcommon';

function WhatsappAction(props) {
    let {
        waOptions,
        triggerSubmit,
        oncancel,
        showModal,
        handleChange,
        recipientOptions,
        channelRecipientOptions,
        onRecipientsChange,
        selectedTemplate,
        handleTemplateChange,
        onFileUpload,
        previewData,
        leadFormDetail,
        formData,
        submitRef,
        waComponents,
        components,
        handleVariableChange,
        submitForm
    } = props;
    const form = useForm();
    const { register, handleSubmit: handleActionFormSubmit, control, formState: { errors }, setError } = form;

    const customSaveAction = async () => {
        let isValidRecipient = validateRecipient();
        if (!isValidRecipient) return;
        submitForm();
    };

    const validateRecipient = () => {
        let recipients = formData['extra_recipients'];
        let errorMsg = "";
        let isValid = true;
        if (recipients !== "" && recipients !== undefined) {
            let tmpMsg = "";
            let recipientArr = recipients.split(",");
            recipientArr.map((recipient) => {
                console.log(recipient)
                let isValid = isValidMobileNumber(recipient);
                console.log("isValid:"+isValid);
                if (!isValid) {
                    tmpMsg = tmpMsg + recipient + " is not valid";
                }
            });
            errorMsg = tmpMsg;
        }
        if (errorMsg !== "") {
            isValid = false;
            setError("extra_recipients", {
                type: "manual",
                message: errorMsg
            });
        }
        return isValid;

    }
    return <Fragment>
        <CommonHeaderContent
            isModal={showModal}
            closeModal={oncancel}
            buttonAction={triggerSubmit}
            headerTitle={"Send Whatsapp"}
            buttonTxt={"Save & Close"}
            buttonIcon={faFloppyDisk}
            mainContent={
                <Fragment>
                    <form name={'workflow_Action'}>
                        <div className='mt-3 '>
                            <Row className='ml-2 automation-section'>
                                <Col md="8">
                                    <div>
                                        <div className={`mb-3`}>
                                            <label className="automation-lbl form-label"> Name </label>
                                            <Controller
                                                name="action_name"
                                                control={control}
                                                rules={{ required: formData.action_name === undefined ? "Please provide Name" : "" }}
                                                render={({ field }) => {
                                                    return (
                                                        <input
                                                            {...field}
                                                            value={formData['action_name'] !== undefined ? formData['action_name'] : ''}
                                                            onChange={
                                                                (e) => {
                                                                    handleChange(e)
                                                                    field.onChange(e)
                                                                }
                                                            }
                                                            name={'action_name'}
                                                            type={'text'}
                                                            className={`form-control ${errors.action_name ? 'is-invalid' : ''}`}
                                                            autoComplete={'off'}
                                                        />
                                                    );
                                                }}
                                            />
                                            {errors.action_name && <em className={`error invalid-feedback`}>{errors.action_name.message}</em>}
                                        </div>
                                        <div className='mb-3'>
                                            <label className="automation-lbl form-label"> Recipients </label>
                                            <Controller
                                                name="recipents"
                                                control={control}
                                                rules={{ required: Object.keys(recipientOptions).length === 0 ? "Please choose recipients" : "" }}
                                                render={({ field }) => {
                                                    return (
                                                        <Select
                                                            {...field}
                                                            isMulti
                                                            placeholder={'---Choose One---'}
                                                            menuPlacement={"auto"}
                                                            menuPosition={'fixed'}
                                                            name={"recipents"}
                                                            id={"recipents"}
                                                            className={`basic-multi-select ${errors.recipents ? 'is-invalid' : ''}`}
                                                            classNamePrefix="wa-select"
                                                            value={recipientOptions}
                                                            onChange={e => {
                                                                onRecipientsChange(e, 'recipents');
                                                                field.onChange(e)
                                                            }}
                                                            options={channelRecipientOptions}
                                                        />
                                                    );
                                                }}
                                            />
                                            {errors.recipents && <em className={`error invalid-feedback`}>{errors.recipents.message}</em>}
                                        </div>
                                        <div className='mb-3'>
                                            <label className="automation-lbl form-label"> Additional Recipients</label>
                                            <Controller
                                                name="extra_recipients"
                                                control={control}
                                                render={({ field }) => {
                                                    return (
                                                        <input
                                                            {...field}
                                                            type="text"
                                                            name="extra_recipients"
                                                            id="extra_recipients"
                                                            value={formData['extra_recipients'] !== undefined ? formData['extra_recipients'] : ''}
                                                            autoComplete={"off"}
                                                            onChange={(e) => {
                                                                handleChange(e)
                                                            }}
                                                            placeholder='Use commas to separate recipients without a space'
                                                            className={`form-control`}
                                                        />
                                                    );
                                                }}
                                            />
                                            {errors.extra_recipients && <em className={`error invalid-feedback`}>{errors.extra_recipients.message}</em>}
                                        </div>

                                        <div className={`mb-3`}>
                                            <label className={''} htmlFor={'templateName'}>{'Template Name'}</label>
                                            <Controller
                                                name="templates"
                                                control={control}
                                                rules={{ required: selectedTemplate === undefined || Object.keys(selectedTemplate).length === 0 ? "Please choose template" : "" }}
                                                render={({ field }) => {
                                                    return (
                                                        <Select
                                                            {...field}
                                                            menuPlacement={"auto"}
                                                            menuPosition={'fixed'}
                                                            name="templates"
                                                            id="templates"
                                                            value={selectedTemplate}
                                                            onChange={e => {
                                                                handleTemplateChange(e, 'wa_template');
                                                                field.onChange(e)
                                                            }}
                                                            options={waOptions}
                                                            className={`basic-multi-select ${errors.templates ? 'is-invalid' : ''}`}
                                                            classNamePrefix="wa-select"
                                                        />
                                                    );
                                                }}
                                            />
                                            {errors.templates && <em className={`error invalid-feedback`}>{errors.templates.message}</em>}
                                        </div>
                                        <div className={``}>
                                            <div className={''}>
                                                <Row className={''}>
                                                    <div className={'d-grid'}>

                                                        <WhatsappComponent
                                                            form={form}
                                                            errors={errors}
                                                            waComponents={waComponents}
                                                            handleInputChange={handleChange}
                                                            onFileUpload={onFileUpload}
                                                            handleTemplateChange={handleVariableChange}
                                                            previewData={previewData}
                                                            leadFormDetail={leadFormDetail}
                                                            formData={formData}
                                                        />
                                                    </div>
                                                </Row>
                                            </div>
                                        </div>

                                    </div>
                                </Col>
                                <Col md="4">
                                    {
                                        components.length > 0 &&
                                        <PreviewPanel components={components} previewData={previewData} waComponents={waComponents} formData={formData} source={'workflow_action'} />
                                    }
                                </Col>
                            </Row>
                            <button ref={submitRef} onClick={handleActionFormSubmit(customSaveAction)} className={`le-button lePrimaryBtn br-4 hide`} color="primary" type={'submit'}>
                                Submit
                            </button>
                        </div>
                    </form>
                </Fragment>
            }
        />
    </Fragment>
}

export default WhatsappAction;